// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__c_7lw","disabled":"style_disabled__2YoHs","default":"style_default__h22Zf","primary":"style_primary__dl0dY","dashed":"style_dashed__hjLXA"};